import { AfterViewInit, Component, OnInit } from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';
import { Subject } from 'rxjs';
import { FlowChartDataService } from '../../../services/flow-chart-data.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'particle-data-survey-confirm-changes-dialog',
  templateUrl: './data-survey-confirm-changes-dialog.component.html',
  styleUrls: ['./data-survey-confirm-changes-dialog.component.scss']
})
export class DataSurveyConfirmChangesDialogComponent  implements OnInit, IDialogView, AfterViewInit {

  data: DialogModel;
  statusTypes: any[] = [{name: 'Keep Open', key: 'KeepOpen'}, {name: 'Complete', key: 'Complete'}];
  ngUnsubscribe = new Subject<void>();
  constructor(private flowChartDataService: FlowChartDataService) {

  }

  ngOnInit() {
    this.data.input.selectedStatusType = 'KeepOpen';
  }
  ngAfterViewInit (): void {

  }
  onSelectStatusChange() {

  }
  onOkClicked(): boolean {
    return true;
  }

}
